import { useStyles } from './styles'
import { $userLanguage, $userToken } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { ProfileCard } from '@/features/unifiedProfileCard'
import { Statistics } from '@/shared/ui/dataWrappers/farcanaStatistics'
import { useCallback, useEffect } from 'react'
import { useHideNav } from '@/shared/hooks/useHideNav'
import { useBackButton } from '@/shared/hooks/useBackButton'
import AppLoading from '@/features/loading'
import { getUserProfileFx } from '@/entities/user'
import { UpdateProgressButton } from '@/features/updateProgressButtons'
import { goToMain } from '@/app/routing/events'
import { usePolling } from '@/shared/hooks/usePolling'
import useGetRefreshingStatus from '@/shared/hooks/useGetRefreshingStatus'
import { $xboxUserData } from '@/entities/platforms/xbox'
import useGetXboxStats from './hooks/useGetXboxStats.tsx'

export const XboxProfileView = () => {
  useHideNav()
  const userToken = useUnit($userToken)
  const handlebb = useCallback(() => goToMain(), [])
  useBackButton({ onBack: handlebb })
  const { isEpicRefreshing } = useGetRefreshingStatus()

  const userLang = useUnit($userLanguage)
  const xboxUserData = useUnit($xboxUserData)
  const xboxStats = useGetXboxStats()

  usePolling(
    () => {
      if (!userToken) return
      void getUserProfileFx(userToken)
    },
    1000,
    !!userToken && isEpicRefreshing
  )

  useEffect(() => {
    if (!userToken) return
    if (!xboxUserData) void getUserProfileFx(userToken)
  }, [xboxUserData, userToken])

  const texts = lang[userLang].pages.xboxProfile

  const { classes } = useStyles()

  if (!xboxUserData) return <AppLoading />

  return (
    <div className={classes.root}>
      <div className={classes.bannerContainer}>
        <img className={classes.logo} src="/assets/svg/xbox-text-logo.webp" alt="" />
        <span className={classes.connectedText}>{texts.connectedSuccessfully}</span>
        <BackgroundShading
          bottom="0px"
          height="80px"
          background={'linear-gradient(0deg, #1D1E22 0%, rgba(29, 30, 34, 0.60) 52%, rgba(29, 30, 34, 0.00) 100%)'}
          zIndex={1}
        />
      </div>
      <div className={classes.contentWrapper}>
        <ProfileCard username={xboxUserData.username} avatarUrl={xboxUserData.avatar_url} balance={xboxUserData.xbox_gigi} />
        <UpdateProgressButton />

        <p className={classes.title}>{texts.legacy}</p>
        <div className={classes.statsList}>
          {xboxStats.map((stat) => (
            <Statistics key={stat.name} value={stat.value} name={stat.name} />
          ))}
        </div>
      </div>
    </div>
  )
}
